import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Am trecut de la oboseală cronică la o viață în care pot respira cu adevărat. Nu credeam că e posibil să mă simt din nou eu. Fără rușine. Cu iubire.',
    author: 'Irina M.',
    role: 'Clientă'
  }, {
    quote: 'Nu am înțeles până la tine că totul e programare și că pot alege ce program păstrez. Mi-ai dat înapoi controlul asupra propriei vieți.',
    author: 'Adriana C.',
    role: 'Clientă'
  }, {
    quote: 'Nu credeam că uleiurile, cristalele și vulnerabilitatea pot merge împreună cu știința. Mi-ai arătat că da și că funcționează.',
    author: 'Mirela D.',
    role: 'Clientă'
  }];
  return <section className="w-full bg-gray-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-234">
      <div className="max-w-7xl mx-auto" data-id="element-235">
        <div className="text-center mb-16" data-id="element-236">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-4" data-id="element-237">
            Ce spun oamenii care au lucrat cu mine
          </h2>
          <div className="w-16 h-0.5 bg-primary mx-auto" data-id="element-238"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-239">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg flex flex-col justify-between h-full relative" data-id="element-240">
              <div className="text-6xl text-light opacity-30 absolute top-4 left-6 font-serif" data-id="element-241">
                "
              </div>
              <p className="text-body italic leading-relaxed mb-8 relative z-10 pt-4" data-id="element-242">
                {testimonial.quote}
              </p>
              <div className="mt-auto" data-id="element-243">
                <div className="w-10 h-0.5 bg-medium mb-3" data-id="element-244"></div>
                <p className="font-bold text-dark" data-id="element-245">
                  {testimonial.author}{' '}
                  <span className="text-medium font-normal" data-id="element-246">
                    · {testimonial.role}
                  </span>
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}